import cartItemsStatuses from 'wix-art-store-3rd-party/dist/src/sdk/cartItemsStatuses';

export function validateItemsStatus(cartItems = []) {
  return !cartItems.some(item => {
    const { status } = item;
    return status === cartItemsStatuses.INVALID;
  });
}

export function validateCartItems(cartItems) {
  let itemsValid = cartItems && Array.isArray(cartItems) && cartItems.length;
  if (itemsValid) {
    itemsValid = validateItemsStatus(cartItems);
  }

  return itemsValid;
}
